import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/auth/useAuth';
import { getVoucher } from '@/api/accountsBooks';
import { VoucherView } from '../books/VoucherRegisterPage';
import { VoucherFormModal } from '../books/VoucherFormModal';

/**
 * Opens a register line's voucher, read-only. With `alterPayments` (the TDS challans), a Payment
 * user may also alter it from there — the challan opens on its own form.
 */
export function useVoucherOpen(alterPayments = false) {
  const [view, setView] = useState<number | null>(null);
  const [alter, setAlter] = useState<number | null>(null);
  const canPay = useAuth().hasPerm('acc-payment');
  const editQ = useQuery({ queryKey: ['acc-books', 'voucher', alter], queryFn: () => getVoucher(alter!), enabled: alter != null });
  const el = (
    <>
      {view != null && <VoucherView id={view} onClose={() => setView(null)} onAlter={alterPayments && canPay ? () => { setAlter(view); setView(null); } : undefined} />}
      {alter != null && editQ.data && <VoucherFormModal type="Payment" voucher={editQ.data} onClose={() => setAlter(null)} />}
    </>
  );
  const open = useCallback((id: number | null | undefined) => (id ? () => setView(id) : null), []);
  return { open, el };
}
